import styled from 'styled-components';
import { Typography } from '@mui/material';
import { Flex, FlexColumn } from '../Flex';
import {
  componentToken,
  fontSize,
  lineHeight,
  radius,
  space,
} from '../../style/utils';
import TestAccordion from './TestAccordion';

const SECTION_TITLE_LINE_HEIGHT = '24px';

export const FieldsWrapper = styled(FlexColumn)`
  gap: ${space('xxl')};
`;

export const NestedFields = styled(FieldsWrapper)`
  border-left: 4px solid ${({ theme }) => theme.palette.border.selected};
  padding: ${space('sm', 'xxl')};
`;

export const FormText = styled(Typography)<{ $muted?: boolean }>`
  color: ${({ $muted, theme }) =>
    $muted ? theme.palette.content.secondary : theme.palette.content.primary};
`;

export const FormTitle = styled(Typography)`
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
`;

export const Row = styled(Flex)`
  align-items: center;
  gap: ${space('lg')};
  width: 100%;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: ${({ theme }) => theme.palette.surface.hover};
`;

export const InputWrapper = styled(FlexColumn)`
  position: relative;
`;

export const ErrorMessage = styled(Typography)`
  position: absolute;
  color: ${({ theme }) => theme.palette.status.error.bright} !important;
  font-size: ${componentToken('formControls.errorText.fontSize')};
  left: 0;
  bottom: -14px;
  line-height: ${componentToken('formControls.errorText.lineHeight')};
  white-space: nowrap;
`;

export const InlineFormContent = styled.div`
  font-size: ${fontSize('base')};

  > span {
    display: inline-block;
    vertical-align: middle;
    margin: ${space(0, 'sm')};
  }
`;

export const SectionTitle = styled(Typography)`
  font-size: ${fontSize('md')};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  line-height: ${SECTION_TITLE_LINE_HEIGHT};
  color: ${({ theme }) => theme.palette.content.secondary};
  text-transform: uppercase;
  letter-spacing: 0.39px;
`;

export const SectionDescription = styled(Typography)`
  color: ${({ theme }) => theme.palette.content.secondary};
`;

export const InfoBox = styled.div`
  background-color: ${({ theme }) => theme.palette.surface.soft};
  padding: ${space('lg')};
  border-radius: ${radius('lg')};
  font-size: ${fontSize('md')};
  line-height: ${lineHeight('md')};
  color: ${({ theme }) => theme.palette.content.primary};
`;

export default {
  FieldsWrapper,
  NestedFields,
  FormText,
  FormTitle,
  Row,
  Divider,
  InputWrapper,
  ErrorMessage,
  InlineFormContent,
  TestAccordion,
  SectionTitle,
  SectionDescription,
  InfoBox,
};
